import { createFileRoute, notFound } from "@tanstack/react-router";
import { AccessoryDetailPage } from "@/components/products/AccessoryDetailPage";
import { accessories } from "@/data/accessories";
import { accessoryDetailSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/products/accessories_/$id")({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
  }),
  loader: ({ location, params }) => {
    if (!accessories.some(({ id }) => id === params.id)) {
      throw notFound();
    }
    return { href: location.href };
  },
  head: ({ loaderData, params }) =>
    accessoryDetailSeo(loaderData?.href ?? `/products/accessories/${params.id}`, params.id),
  component: AccessoryDetailRoute,
});

function AccessoryDetailRoute() {
  const { id } = Route.useParams();
  const { tab } = Route.useSearch();
  return <AccessoryDetailPage id={id} initialTab={tab} />;
}
